'use strict';
class ValidDirective {
    restrict = 'A';
    require = 'ngModel';

    link(scope, element, attr, ngModelCtrl) {
        scope.$watch(
            () => scope.$eval(attr.valid),
            (newValue) => ngModelCtrl.$setValidity('valid', newValue)
        );

        ngModelCtrl.$parsers.push((viewValue) => {
            ngModelCtrl.$setValidity('valid', scope.$eval(attr.valid));
            return viewValue;
        });
    }
}

export let valid:any = () => new ValidDirective();


// WEBPACK FOOTER //
// ./src/main/ui/core/directives/validation/valid.directive.ts